import type {
  DemoDayLoginBody,
  DemoDayLoginResponse,
  ListDemoDayCompaniesQuery,
  ListDemoDayCompaniesResponse,
  ListDemoDayViewersQuery,
  ListDemoDayViewersResponse,
  RetrieveDemoDayResponse,
  FetchSchedulingLinkQuery,
  FetchSchedulingLinkResponse,
  ListDemoDayInvestorsQuery,
  ListDemoDayInvestorsResponse,
  DemoDayProfileBody,
} from '$shared/api';
import { BaseService } from './utils/BaseService';

export class DemoDayService extends BaseService {
  retrieveDemoDay(): Promise<RetrieveDemoDayResponse> {
    return this.client.send('/api/demo-day', {
      method: 'GET',
    });
  }

  listDemoDayCompanies(
    query?: ListDemoDayCompaniesQuery,
  ): Promise<ListDemoDayCompaniesResponse> {
    return this.client.send('/api/demo-day/companies', {
      method: 'GET',
      query,
    });
  }

  listDemoDayViewers(
    query: ListDemoDayViewersQuery,
  ): Promise<ListDemoDayViewersResponse> {
    return this.client.send('/api/demo-day/viewers', {
      method: 'GET',
      query,
    });
  }

  listDemoDayInvestors(
    query?: ListDemoDayInvestorsQuery,
  ): Promise<ListDemoDayInvestorsResponse> {
    return this.client.send('/api/demo-day/investors', {
      method: 'GET',
      query,
    });
  }

  fetchSchedulingLink(
    query: FetchSchedulingLinkQuery,
  ): Promise<FetchSchedulingLinkResponse> {
    return this.client.send('/api/demo-day/scheduling-link', {
      method: 'GET',
      query,
    });
  }

  login(body: DemoDayLoginBody): Promise<DemoDayLoginResponse> {
    return this.client.send('/api/demo-day/login', {
      method: 'POST',
      body,
    });
  }

  updateProfile(body: DemoDayProfileBody): Promise<void> {
    return this.client.send('/api/demo-day/profile', {
      method: 'POST',
      body,
    });
  }
}
